import classNames from "classnames";
import { storyblokSrcSet, STORYBLOK_IMAGE_WIDTHS } from "@utils/images/storyblokImage";
import StoryblokImage from "./StoryblokImage";

// Must match the breakpoint used in the SCSS of the Storyblok banners.
const DESKTOP_MEDIA = "(min-width: 768px)";

// Desktop / mobile art direction: the browser only downloads the image matching the viewport,
// unlike two <img> toggled with `display: none` which are both downloaded.
function StoryblokPicture({
  desktopSrc,
  mobileSrc,
  desktopWidths = STORYBLOK_IMAGE_WIDTHS.fullWidthDesktop,
  mobileWidths = STORYBLOK_IMAGE_WIDTHS.fullWidthMobile,
  sizes = "100vw",
  pictureClassName,
  ...props
}) {
  const fallbackSrc = mobileSrc || desktopSrc;
  const fallbackWidths = mobileSrc ? mobileWidths : desktopWidths;
  const desktopSrcSet = desktopSrc && mobileSrc && storyblokSrcSet(desktopSrc, desktopWidths);

  if (!fallbackSrc) return null;

  return (
    <picture className={classNames("d-block", pictureClassName)}>
      {desktopSrcSet && (
        <source
          media={DESKTOP_MEDIA}
          srcSet={desktopSrcSet}
          sizes={sizes}
        />
      )}
      <StoryblokImage
        src={fallbackSrc}
        widths={fallbackWidths}
        sizes={sizes}
        {...props}
      />
    </picture>
  );
}

export default StoryblokPicture;
